var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"查阅","visible":_vm.visible,"close-on-click-modal":false,"width":"900px"},on:{"close":_vm.close}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.lookContent)}}),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.close}},[_vm._v("关闭")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }